<template>
  <div class="bigbox">
    <div class="inCon1">
      <p>营业税金及附加</p>
      <input type="text" placeholder="请输入金额" v-model="Amount">
    </div>
    <div class="inCon2">
      <p>申报日期</p>
      <p>
        <input class="js-startdate-picker" type="text" placeholder="请选择" v-model="selectBirthDate" readonly>
        <a href="javascript:;">
          <img src="../../../static/img/xjiant.png" alt="">
        </a>
      </p>
    </div>
    <div class="con">营业税金及附加子类别</div>
    <div class="inCon1" v-for="(item,i) in Subcategory" :key="i">
      <p>{{item.Name}}</p>
      <input type="text" placeholder="请输入金额" @change="sub(i,item)">
    </div>
    <footer>
      <div class="btn" @click="AddSalesTaxRecord()">
        提交
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "salestax",
    data() {
      return {
        selectBirthDate: '',
        Subcategory: [],
        Amount: '',
        EducationFee: 0,
        Sales: 0,
        UrbanConstruction: 0,
        Resource: 0,
        LandValue: 0,
        UrbanLand: 0,
        Property: 0,
        VehicleVessel: 0,
        MineralResources: 0,
        Dischargefee: 0,
        Stampduty: 0,
        money: '',
      }
    },
    mounted() {
      this.BirthDateSelect()
      this.GetSalesTaxAllDetail()
    },
    methods: {
      changeText(event, i) {
        console.log(i)
        console.log(event.target.value)
      },
      accAdd(arg1, arg2) {
        if (!arg1) {
          arg1 = 0;
        }
        if (!arg2) {
          arg2 = 0;
        }
        arg1 = arg1.toString().replace(/\,/g, "");
        arg2 = arg2.toString().replace(/\,/g, "");

        var r1, r2, m, c;
        try {
          r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
          r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
          var cm = Math.pow(10, c);
          if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
          } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
          }
        } else {
          arg1 = Number(arg1.toString().replace(".", ""));
          arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
      },
      sub(i, item) {
        console.log(item)
        if (item.Name === '营业税') {
          this.changeText(event, i)
          this.Sales = event.target.value
          console.log(this.Sales)
        } else if (item.Name === '城市维护建设税') {
          this.changeText(event, i)
          this.UrbanConstruction = event.target.value
          console.log(this.UrbanConstruction)
        } else if (item.Name === '教育费附加') {
          this.changeText(event, i)
          this.EducationFee = event.target.value
        } else if (item.Name === '消费税') {
          this.changeText(event, i)
          this.Excise = event.target.value
          console.log(this.Excise)
        } else if (item.Name === '资源税') {
          this.changeText(event, i)
          this.Resource = event.target.value
          console.log(this.Resource)
        } else if (item.Name === '土地增值税') {
          this.changeText(event, i)
          this.LandValue = event.target.value
          console.log(this.LandValue)
        } else if (item.Name === '城镇土地使用税') {
          this.changeText(event, i)
          this.UrbanLand = event.target.value
          console.log(this.UrbanLand)
        } else if (item.Name === '房产税') {
          this.changeText(event, i)
          this.roperty = event.target.value
          console.log(this.roperty)
        } else if (item.Name === '车船税') {
          this.changeText(event, i)
          this.VehicleVesse = event.target.value
          console.log(this.VehicleVesse)
        } else if (item.Name === '矿产资源补偿费') {
          this.changeText(event, i)
          this.MineralResources = event.target.value
          console.log(this.MineralResources)
        } else if (item.Name === '排污费') {
          this.changeText(event, i)
          this.Dischargefee = event.target.value
          console.log(this.Dischargefee)
        } else if (item.Name === '印花税') {
          this.changeText(event, i)
          this.Stampduty = event.target.value
          console.log(this.Stampduty)
        }
        var a = this.accAdd(Number(this.Sales), Number(this.UrbanConstruction))
        var b = this.accAdd(Number(this.Excise), Number(this.EducationFee))
        var c = this.accAdd(Number(this.Resource), Number(this.LandValue))
        var d = this.accAdd(Number(this.UrbanLand), Number(this.Property))
        var e = this.accAdd(Number(this.VehicleVessel), Number(this.MineralResources))
        var f = this.accAdd(Number(this.Dischargefee), Number(this.Stampduty))
        var ab = this.accAdd(a, b)
        var cd = this.accAdd(c, d)
        var ef = this.accAdd(e, f)
        var aa = this.accAdd(ab, cd)
        this.Amount = this.accAdd(aa, ef)

        // ++Number(this.UrbanConstruction)+Number(this.EducationFee)Number(this.Excise),,Number(this.EducationFee)
        console.log(this.Amount)
      },
      AddSalesTaxRecord() {
        // var params=JSON.stringify({
        //
        // })
        this.$axios({
          method: 'post',
          url: '/fmsapi/TaxProvisionRecord/AddSalesTaxRecord',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
            Amount: this.Amount,
            Date: this.selectBirthDate.replace(/-/g, "/").replace(/-/g, "/").replace(/-/g, ""),
            Excise: this.Excise === undefined ? 0 : this.Excise,
            EducationFee: this.EducationFee === undefined ? 0 : this.EducationFee,
            Sales: this.Sales === undefined ? 0 : this.Sales,
            UrbanConstruction: this.UrbanConstruction === undefined ? 0 : this.UrbanConstruction,
            Resource: this.Resource === undefined ? 0 : this.Resource,
            LandValue: this.LandValue === undefined ? 0 : this.LandValue,
            UrbanLand: this.UrbanLand === undefined ? 0 : this.UrbanLand,
            Property: this.Property === undefined ? 0 : this.Property,
            VehicleVessel: this.VehicleVessel === undefined ? 0 : this.VehicleVessel,
            MineralResources: this.MineralResources === undefined ? 0 : this.MineralResources,
            Dischargefee: this.Dischargefee === undefined ? 0 : this.Dischargefee,
            Stampduty: this.Stampduty === undefined ? 0 : this.Stampduty,
            Operation: '',
            TaxID: '',
          })
        }).then(res => {
          console.log(res.data)
          console.log(this.Excise)
        })
        // this.$axios.post('',params,{
        //   headers: {
        //     'Content-Type': 'application/json;'
        //   }
        // }).then(res=>{
        //   console.log(res)
        // })
      },
      GetSalesTaxAllDetail() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/TaxProvisionRecord/GetSalesTaxAllDetail',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.Subcategory = res.data.result

          console.log(res.data.result)
        })
      },
      Recordincome() {
        this.$router.push({path: '/Recordincome'})
      },
      BirthDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      sale() {
        this.$router.push({path: '/sale'})
      },
      find() {
        this.$router.push({path: '/findfees'})
      },
      taxa() {
        this.$router.push({path: '/taxa'})
      },
      back() {
        this.$router.push('/home')
      },
    }

  }
</script>

<style scoped>
  html, body {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  /*大盒子，首位固定*/
  .bigbox {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;

  }

  input {
    text-align: right;
    font-size: 16px;
  }

  /*头部固定*/
  header {
    height: 3.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff
  }

  /*头部标题*/
  .head {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1.3rem;
    color: black;
  }

  /*标题样式*/
  .head h2 {
    display: block;
    width: 25rem;
    text-align: center;
  }

  .head img:last-child {
    width: 1.5rem;
    height: 1.1rem;
  }

  .head img:first-child {
    width: 0.9rem;
    height: 1.7rem;
  }

  section {
    flex: 1;
    overflow: auto;
  }

  .Topmain {
    height: 1.5rem;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  .Topmain a {
    display: block;
    width: 1.7rem;
    height: 3.3rem;
    background: white;
    border-radius: 8px;
    color: black;
    text-align: center;
    line-height: 3.2rem;
    margin-left: 10px;
  }

  .Topmain a:nth-child(2) {
    background: #09a9bf;
    color: white
  }

  .maincon {
    width: 100%
  }

  .topcon {
    background: white;
    height: 15.4rem;
    padding: 0 0.19rem;
  }

  .botcon {
    background: white;
    height: 2.3rem;
    padding: 0 1.9rem;
    margin-top: 0.5rem
  }

  .con {
    height: 5.5rem;
    background: white;
    color: #09a9bf;
    font-size: 1.4rem;
    line-height: 5.4rem;
    border-bottom: 1px solid #d8d8d8
  }

  .inCon1 {
    height: 4.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #d8d8d8;
  }

  .inCon1:last-child {
    border-bottom: none
  }

  .inCon1 p {
    width: 12rem;
    height: 100%;
    line-height: 4.6rem;
    font-size: 1.3rem;
    color: black;
  }

  .inCon1 input {
    display: block;
    width: 13.7rem;
    height: 4.6rem;
    font-size: 2rem;
    text-align: right;
  }

  .inCon2 {
    height: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #d8d8d8;
    border-bottom: none
  }

  .inCon2 p {
    font-size: 1.3rem;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .inCon2 p:last-child {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .inCon2 img {
    width: 1.2rem;
    height: 0.7rem;
  }

  footer {
    display: flex;
    height: 5.5rem;
    background: white;
    justify-items: center;
    align-items: center;
  }

  .btn {
    margin: 0 auto;
    width: 30rem;
    height: 3.5rem;
    background: #379ce2;
    font-size: 1.4rem;
    text-align: center;
    line-height: 3.5rem;
    border-radius: 20px;
  }
</style>
